import React from 'react';
import styled from 'styled-components';
import { IBinning } from '../../../../../redux/slices/oldBuilder/binning/types';
import { BucketDefType } from '../../../../../utils/apollo/graphqlSchema';
import BuilderInfo from '../../../../BuilderInfo';
import { BasicEntity, VersionedEntity } from '../../../../EntityLabels';
import { MaybeNil } from '../../../../../utils/interfaces';
import { UnreachableCaseError } from 'ts-essentials';

interface IProps {
  binning: MaybeNil<IBinning>;
  subjectName?: string;
}

const Container = styled(BasicEntity)`
  padding: 0;
  background-color: unset;
`;

const NamedContainer = styled(VersionedEntity)`
  padding: 0;
`;

export default ({ binning, subjectName }: IProps) => {
  const getContent = () => {
    if (!binning) {
      return null;
    }

    if (binning.type === BucketDefType.Named) {
      const namedBucketDef = binning.namedBucketDef;
      return (
        <NamedContainer
          label={namedBucketDef.name}
          isDisabled={namedBucketDef.isDisabled}
          backgroundColor="transparent"
          hideClearButton={true}
          isLatestVersion
        >
          <BuilderInfo kind="namedBucketDef" namedBucketDef={namedBucketDef} />
        </NamedContainer>
      );
    } else if (binning.type === BucketDefType.Basic) {
      return (
        <NamedContainer
          label="Custom"
          isDisabled={false}
          backgroundColor="transparent"
          hideClearButton={true}
          isLatestVersion
        >
          <BuilderInfo kind="basicBucketDef" basicBucketDef={binning} />
        </NamedContainer>
      );
    } else {
      throw new UnreachableCaseError(binning);
    }
  };

  if (subjectName) {
    return (
      <Container variant="white">
        {subjectName}
        {' { '}
        {getContent()}
        {' } '}
      </Container>
    );
  }

  return <Container variant="white">{getContent()}</Container>;
};
